import React from 'react';
import PropTypes from 'prop-types';
import GiftCardStatistics from '../containers/GiftCardStatistics';
import GiftCardsLookup from '../containers/GiftCardsLookup';
import GiftCardsDownload from '../containers/GiftCardsDownload';
import GiftCardList from '../containers/GiftCardList';
import GiftCardForm from '../containers/GiftCardForm';
import AddGiftCard from '../containers/AddGiftCard';
import { containerApp } from '../../../../main';
import GiftCardModal from '../containers/GiftCardModal';

const GiftCards = ({ giftCard, setGiftCard }) => (
  <div className="u-p u-m-">
    <div className="o-flexbox o-flexbox--content-align-center">
      <div className="u-flex-1 u-mr-auto">
        <GiftCardsLookup giftCard={giftCard} setGiftCard={setGiftCard} />
      </div>
      <div display-if={!containerApp.isActive()}>
        <GiftCardsDownload />
      </div>
      <AddGiftCard />
    </div>
    <div className="u-mt++">
      <GiftCardForm />
    </div>
    <div className="u-mt+">
      <GiftCardStatistics />
    </div>
    <GiftCardList setGiftCard={setGiftCard} />
    <GiftCardModal giftCard={giftCard} setGiftCard={setGiftCard} closeModal={() => setGiftCard(giftCard)} />
  </div>
);

GiftCards.propTypes = {
  giftCard: PropTypes.object.isRequired,
  setGiftCard: PropTypes.func.isRequired,
};

export default GiftCards;
